/* 全局sage */
import { all, call, fork, put, select, take, actionChannel, takeEvery } from 'redux-saga/effects';
import { buffers } from 'redux-saga';
import cookie from 'js-cookie';
import hua from '@hweb/hua-js';
import { getCookieAndWindow, saveCookieAndWindow } from '@common/utils/utils';

import * as api from '../../../common/services';

import * as globalAction from './actions';

import { selectAppInit, selectGeeData, selectPreLoad } from './reducers';
import { UNIVERSAL_CONST } from '@common/utils/constants';
import { CommonErrorText, SmsAuthText, ConfirmBtnText } from '@common/utils/global.text.config';

// 获取token
import { getUrlQuery } from '../../../common/utils/token';
import * as apis from '../../../common/services';
// 对接风控
import pagEgis from '../../../common/utils/payEgis';

/* app 主流程 */
function* main() {
    while (true) {
        yield take(globalAction.INIT_APP);

        yield call(checkAppInit);
    }
}

export function* checkAppInit() {
    const appInit = yield select(selectAppInit);
    if (!appInit) {
        yield call(initApp);
        yield put(globalAction.initAppDone());
    }
}

function* initApp() {
    // 对接风控
    // yield fork(payEgis)
}

/* ******* watcher ******* */

function* watchRegister() {
    yield all([fork(watchPutMessage)]);
}

function* watchPutMessage() {
    // 生成消息队列 依次推送消息
    const chan = yield actionChannel(globalAction.PUT_MESSAGE, buffers.sliding(3));
    while (true) {
        const { msg } = yield take(chan);
        yield put(globalAction.showMessage(msg));
        yield call(delay, 3500);
        yield put(globalAction.hideMessage());
    }
}

/* ******** worker ******** */

// 对接风控
function* payEgis() {
    const uuid = yield call(pagEgis);
    yield put(globalAction.payEgisSuccess(uuid));
}

/* ******** global methods ******** */

// 延迟
export function delay(time) {
    return new Promise(function(re, rj) {
        setTimeout(function() {
            re();
        }, time);
    });
}

// 封装checkRes方法 对华住活动后端的响应数据进行处理
export function* checkRes({ api, data, success, failed, loading, url }) {
    // 统一loading处理
    if (loading) {
        yield put(globalAction.showLoading());
    }

    const res = yield call(api, data, url);
    const code = parseInt(res.code || res.status, 10);
    if (code === 200) {
        // 服务端响应成功
        yield success(res.data, res);
    } else if (code === 400) {
    } else if (code === 406) {
    } else if (code === 600) {
        // 服务端业务逻辑处理失败
        // yield put(globalAction.putMessage(res.msg))
        yield failed(res.msg, res);
    } else if (code === 500) {
        yield put(globalAction.putMessage('服务忙，请稍后再试'));
        yield failed(res.msg, res);
    } else if (code === 603) {
        // yield put(globalAction.showModal(res.msg));
    } else if (code === 521) {
        yield failed(code, res.msg);
    } else if (code === 3000) {
        // yield put(globalAction.putMessage('没有查询到酒店信息'));
        yield failed(code, res.msg);
    } else if (code === 3001) {
        yield put(globalAction.putMessage('请关闭当前页面，重新点击Huazhu开头WiFi连接'));
        yield failed(code, res.msg);
    } else if (code === 3005) {
        yield put(globalAction.putMessage('您今天已输错20次，该设备今天已不能使用上网服务'));
        yield failed(code, res.msg);
    } else if (code === 3006) {
        yield put(globalAction.putMessage('验证码输入错误，请重新输入'));
        yield failed(code, res.msg);
    } else if (code === 3011) {
        yield put(globalAction.putMessage('验证码发送次数达到上限'));
        yield failed(code, res.msg);
    } else if (code === 3012) {
        yield put(globalAction.putMessage('您操作太过频繁'));
        yield failed(code, res.msg);
    } else if (code === 3013) {
        yield put(globalAction.putMessage('验证码发送失败，请重新获取'));
        yield failed(code, res.msg);
    } else if (code === 3007) {
        // yield put(globalAction.putMessage('用户名或密码错误'));
        yield failed(code, res.msg);
    } else if (code === 3008) {
        yield put(globalAction.putMessage('请关闭当前页面，重新点击Huazhu开头WiFi连接'));
        yield failed(code, res.msg);
    } else if (code === 3009) {
        yield put(globalAction.putMessage('请关闭当前页面，重新点击Huazhu开头WiFi连接'));
        yield failed(code, res.msg);
    } else if (code === 3010) {
        yield put(globalAction.putMessage('连网失败，重新点击Huazhu开头WiFi连接'));
        yield failed(code, res.msg);
    } else if (code === 3020) {
        yield put(globalAction.putMessage('未查询到您的入住信息，请确认姓名房间号正确'));
        yield failed(code, res.msg);
    } else {
        // 其他异常
        yield failed('code校验失败', res);
    }

    // 统一loading处理
    if (loading) {
        yield put(globalAction.hideLoading());
    }
    // yield put(globalAction.hideLoading());
}

//MARK: 第二版统一接口处理
export function* checkV2Res({ api, data, success, failed, loading, url }) {

  let pageLan = getUrlQuery('pageLan') || getCookieAndWindow('pageLan');

  if (!pageLan) {
    pageLan = UNIVERSAL_CONST.PAGE_LAN.CN
  }

    // 统一loading处理
    if (loading) {
        yield put(globalAction.showLoading());
    }

    const res = yield call(api, data, url);
    const code = parseInt(res.code || res.status, 10);
    const businessCode = parseInt(res.businessCode);

    if (code === 200) {
        // 服务端响应成功
		if (businessCode == 1000) {
        	yield success(res.content, res);
		} else {
			let _errMsg = CommonErrorText[pageLan]
			if (businessCode == 1011) {
				_errMsg = SmsAuthText['smsOverTime'][pageLan]
			}

			if (businessCode == 1012) {
				// _errMsg = '短信验证码错误'
				_errMsg = SmsAuthText['smsError'][pageLan]
			}

			if (businessCode == 2001) {
				// _errMsg = '短信验证码依然有效'
				_errMsg = SmsAuthText['smsStillValid'][pageLan]

			}
			
			if (businessCode == 2002) {
				// _errMsg = '手机号错误'
				_errMsg = SmsAuthText['phoneError'][pageLan]
			}

			if (businessCode == 1021) {
				_errMsg = ''
				yield put(globalAction.hideMessage());
				hua.showModal({
					content: _errMsg = SmsAuthText['smsErrHigh'][pageLan],
					showCancel: false,
					confirmText: ConfirmBtnText[pageLan],
					onOk() {}
				});
			}

			

			if (_errMsg) {
				// yield put(globalAction.putMessage(_errMsg));
			}
			yield failed(res);
		}
    } else {
        // 其他异常
        yield failed('code校验失败', res);
    }

    // 统一loading处理
    if (loading) {
        yield put(globalAction.hideLoading());
    }
    // yield put(globalAction.hideLoading());
}

//MARK: 接口处理 V24
export function* checkV24Res({ api, data, success, failed, loading, url }) {
    // 统一loading处理
    if (loading) {
        yield put(globalAction.showLoading());
    }

    const res = yield call(api, data, url);

    if (res.success) {
      yield success(res.content, res);
    } else {
			yield failed(res, res);
    }

    // 统一loading处理
    if (loading) {
        yield put(globalAction.hideLoading());
    }
}


function* geeInit() {
    let geeData = yield select(selectGeeData);
    window.initGeetest(
        {
            // 以下 4 个配置参数为必须，不能缺少
            gt: geeData.gt,
            challenge: geeData.challenge,
            offline: !geeData.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: geeData.new_captcha, // 用于宕机时表示是新验证码的宕机
            product: 'bind', // 产品形式，包括：float，popup
            width: '300px',
            https: true,
            // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        },
        function(geeCaptchObj) {
            window.geeCaptchObj = geeCaptchObj;
            window.geeCaptchObj
                .onReady(function() {})
                .onSuccess(function() {
                    var result = window.geeCaptchObj.getValidate();
                    if (!result) {
                        return put(globalAction.putMessage('请完成验证'));
                    }
                    return window.geeValidateCallBack(result);
                });
        }
    );
}

function* geeVerify({ callback }) {
    window.geeValidateCallBack = callback;
    yield window.geeCaptchObj.verify();
}
function* watchPageRecord() {
    yield takeEvery(globalAction.GEE_INIT, geeInit);
    yield takeEvery(globalAction.GEE_VERIFY, geeVerify);
}

export default function* appSaga() {
    yield fork(main);
    yield fork(watchRegister);
    yield fork(watchPageRecord);
}
